<ng-template #forgotPasswordModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">
      Forgot Password
    </h4>
    </div>

    <div class="modal-body">
      <div>
        <p>
          Please type in the email address associated with your SCOHR account and click Submit.
        </p>
        <form>
          <div class="row">&nbsp;</div>
          <div class="row">
            <div class="col-6">
              <input [(ngModel)]="user.eMailAddress" type="text" class="form-control" aria-label="eMail Address"
                     aria-describedby="basic-addon1" name="eMailAddress">
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" id="cancel-edit-btn"  (click)="closeModals()">Cancel</button>
        <button type="button" color="primary" id="add-override" (click)="processForgot()">Submit</button>
      </div>
    </div>
</ng-template>
